import React from "react";
import Banner from "./Banner";
import Footer from "./Footer";

const Our_Values = () => {
  return (
    <>
      <Banner />
      <div className="home_header">
        <h1 className="home_header">OUR VALUE</h1>
      </div>

      <div className="value_info">
        <p>
          The core values that bind TIME Cyber Media together are integrity,
          accountability and commitment with the objective to
          <br />
          translating business advice into measurable market results. We aim to
          bring invaluable insight and growth to our clients by
          <br />
          as well as promises. We believe in developing client relationships on
          the basis of the highest ethical and moral standards
          <br />
          around the world and measure our success through that. As a vital
          measure of integrity, we ensure the health and safety of our
          <br />
          communities, and protect the environment in all we do. We ensure
          accountability and complete transparency with all our
          <br />
          business dealings. We accept responsibility for our actions. We make
          and support business decisions through experience
          <br />
          and good judgment. Our commitment to our work is visible not only in
          deliverables and in meeting deadlines but also in our
          <br />
          values, vision and mission. We believe that meaningful change can only
          be brought about through innovation and by looking
          <br />
          at challenges and opportunities from new angles and exercising our
          curiosity.
        </p>
      </div>

      <Footer />
    </>
  );
};

export default Our_Values;
